"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = difference;
var _index = require("../../../lib-vendor/internmap/src/index.js");
function difference(values) {
  values = new _index.InternSet(values);
  for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }
  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }
  return values;
}